










import { Component, Prop, Vue } from "vue-property-decorator";
@Component({})
export default class AppAddInstruction extends Vue {
  onAddInstruction() {
    this.$router.push({
      name: "add-instruction",
      query: { previous: "instructions" },
    });
  }
}
